export default "__VITE_ASSET__2611988a__"